import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import App from "./App";
import "./index.css";

import { initSentry } from "./lib/sentry";
import { initAnalytics } from "./lib/analytics";
import { initFeedbackWidget } from "./lib/feedback";
import { SettingsProvider } from "./hooks/useSettings";
import { GetAppProvider } from "./components/ui/GetAppModal";

// SynthOS platform seams — wired at boot, each a safe no-op when unconfigured.
initSentry();
initAnalytics();
initFeedbackWidget();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <SettingsProvider>
          <GetAppProvider>
            <App />
          </GetAppProvider>
        </SettingsProvider>
      </MotionConfig>
    </BrowserRouter>
  </React.StrictMode>
);
